"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var EmailOpenSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M15,5.7453877 L15,13 C15,13.5522847 14.5522847,14 14,14 L4,14 C3.44771525,14 3,13.5522847 3,13 L3,5.7453877 L8.11774245,2.02339319 C8.64371822,1.64086536 9.35628178,1.64086536 9.88225755,2.02339319 L15,5.7453877 Z M14,7.60207025 L9.94283566,10.8809072 C9.39285389,11.3253803 8.60714611,11.3253803 8.05716434,10.8809072 L4,7.60207025 L4,13 L14,13 L14,7.60207025 Z M9,10.357131 C12.3557638,7.64815991 14.0336456,6.28986351 14.0336456,6.28224182 C14.0336456,6.27462013 12.3557638,5.05328907 9,2.61824866 L3.96148682,6.28224182 L9,10.357131 Z" })));
};
EmailOpenSmall.displayName = 'EmailOpenSmall';
exports.default = EmailOpenSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=EmailOpenSmall.js.map